import React from 'react';
import PropTypes from 'prop-types'; // ES6

/**
 * Crea un element <li> quan el valor a representar es de tipus icona
 * @param valor
 * @returns {Element}
 */
const crearElementLlistaLlegendaPerIcones = (valor) => {

    const { nom, iconaURL } = valor;

    return (
        <li key={nom} className='observacions-mapa-llegenda-colors-imatge'>
            <img alt='' src={iconaURL} />
            {nom}
        </li>
    );

};

/**
 * Crea un element DOM <li> amb la representació del valor especificat. L'element tindra un <span> amb el colorcorrespontn segons el valor i
 * un numero asociat.
 * @param valor
 * @returns {Element|*}
 */
const crearElementLlistaLlegendaPerColors = (valor) => {

    const { colorRGB, condicions } = valor;

    return (
        <li key={colorRGB} className='observacions-mapa-llegenda-colors-color'>
            <span style={{backgroundColor: `rgb(${colorRGB})`}} />
            <span>{condicions[0]}</span>
        </li>
    );

};

const ObservacioMapaLlegenda = (props) => {

    const { paleta, titolLlegenda, esDeTipusIcona } = props;

    const metodeRenderitzarPaleta = (esDeTipusIcona) ? crearElementLlistaLlegendaPerIcones : crearElementLlistaLlegendaPerColors;

    return (
        <div>
            <span className='observacions-mapa-llegenda-titol'>{titolLlegenda}</span>
            <ul className='observacions-mapa-llegenda-colors'>
                { paleta.map(metodeRenderitzarPaleta) }
            </ul>
        </div>
    );

};

ObservacioMapaLlegenda.propTypes = {
    paleta: PropTypes.array,
    titolLlegenda: PropTypes.string,
    esDeTipusIcona: PropTypes.bool
};

export default ObservacioMapaLlegenda;


// WEBPACK FOOTER //
// ./src/components/observacio/observacioMapaLlegenda.js